<template>
  <ul class="pro-flex-list">
    <li
      class="pro"
      v-for="(item) in list"
      :key="item.id"
      :class="item.image_url?'active'+' '+row:'not'+' '+row"
    >
      <template v-if="item.cover_img">
        <router-link :to="{name:'auction',params: {goodsId:item.id}}" target="_blank">
          <div class="pro-img">
            <img v-lazy="item.cover_img" alt :key="item.cover_img">
            <div class="li-title">{{item.name}}</div>
          </div>



          <div class="img-pop todo" v-if="item.auction_status == 1">即将开始</div>
          <div class="img-pop doing" v-else-if="item.auction_status == '2'">正在进行</div>
          <div class="img-pop done" v-else-if="(item.auction_status == '3' || item.auction_status == '4' || item.auction_status == '5') ">已结束 </div>


          <div class="pro-content">
			  <div class="li-price todo" v-if="item.auction_status == 4">竞拍失败</div>
            <div class="li-price todo" v-if="item.auction_status == 1">起拍价 <span class="symbol">￥</span> <span class="price-num">{{item.start_price||'0.00'}}</span></div>

            <div class="li-price doing" v-if="item.auction_status == 2">当前价 <span class="symbol">￥</span><span class="price-num">{{item.current_auction_price || '0.00'}}</span> 

            </div>

            <div class="li-price doing" v-if="item.auction_status == 2">

            <span class="current-user" v-if="item.log.user">出价人:{{item.log.user.nickname}}</span></div>



            <div class="li-price done" v-if="item.auction_status == 3 || item.auction_status == 5">
              成交价 <span class="symbol">￥</span><span class="price-num">{{item.current_auction_price || '0.00'}}</span>
            </div>

            <div class="li-price" v-if="item.auction_status == 3 || item.auction_status == 5 ">
              <span class="current-user">中标人:{{ item.log.userInfo && item.log.userInfo.nickname || ''}}</span>
            </div>

            <div class="time ing" v-if="item.auction_status == 2"> 预计 {{item.end_time}} 结束
            </div>
            <div class="time ing" v-if="item.auction_status == 1">
               <span class="ing-txt">开拍时间</span> {{item.start_time}}
            </div>

            <div class="time end" v-if="(item.auction_status == 3 || item.auction_status == 4 || item.auction_status == 5)  && item.bond_money>0 && item.return_bond != 1 && item.need_bond =='1'">待退保证金</div>

            <div class="time end" v-if="(item.auction_status == 3 || item.auction_status == 4 || item.auction_status == 5) && item.bond_money>0 && item.return_bond == 1 && item.need_bond =='1'">已退保证金</div>

            <el-tag class="el-tag"  color="#409eff" effect="dark" size="mini" v-if="item.need_bond == 1">有保证金</el-tag>

            <div class="bot">
              <div>{{item.watch_num || 0}} <span>人次围观</span></div>
              <div>{{item.enroll_num || 0}}  <span>人次出价</span></div>
            </div>

          </div>
        </router-link>
      </template>
    </li>
  </ul>
</template>
<script>
// import { mapActions } from "vuex";
export default {
  components: {},
  props: {
    row: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.pro-flex-list {
  display: flex;
  flex-flow: row wrap;
  // justify-content: space-between;
  .pro {
    position: relative;
    width: 24%;
    height: 438px;
    margin-bottom: 14px;
    background: #fff;
    transition: all 0.25s linear;
    box-sizing: border-box;
    border: 1px solid #eaeaea;
    margin-left: 16px;
    &:nth-child(4n - 3) {
      margin-left: 0;
    }
    
    &-content {
      // padding: 0 13px;
      height: 130px;
      box-sizing: border-box;
      color: #999;
      font-size: 12px;
      line-height: 20px;
      position: relative;
      .bot {
        display: flex;
        border-top: 1px solid #eaeaea;
        height: 36px;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        div {
          align-items: center;
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          &:first-child {
            border-right: 1px solid #eaeaea;
          }
        }
      }
      .time {
        padding: 0 13px;
      }
      .li-price {
        padding-top: 10px;
        padding: 0 13px;
        &.todo{
          .symbol {
            color: #19aa6b;
            font-size: 16px;
          }
          .price-num{
            color: #19aa6b;
            font-size: 26px;
          }
        }

        &.doing{
          .symbol {
            color: #f44;
            font-size: 16px;
          }
          .price-num{
            color: #f44;
            font-size: 26px;
          }
        }

        &.done{
          .symbol {
            font-size: 16px;
          }
          .price-num{
            font-size: 26px;
          }
        }
      }
      
    }
    &.active:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .pro-handle-icon {
        display: block;
      }
    }
    

    .img-pop {
      position: absolute;
      left: 0;
      top: 50px;
      width: 90px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-top-right-radius:30px ;
      border-bottom-right-radius:30px ;
      z-index: 99;
      font-weight: bold;
      font-size: 16px;
      &.todo {
        color: #fff;
        background: #19aa6b;
      }

      &.doing {
        color: #fff;
        background: #f44;
      }
      &.done {
        color: #999;
        background:#f6f6f6;
      }
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
      .pro-img {
        width: 100%;
        height: 292px;
        margin: 0 auto 10px;
        position: relative;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .li-title {
          position: absolute;
          box-sizing: border-box;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 30px;
          line-height: 30px;
          background: rgba(255,255,255,.9);
          color: #000;
          font-size: 14px;
          padding: 0 13px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

      }
      .title {
        margin: 0 10px;
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        font-weight: 400;
        color:#666;
        span-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        span-align: center;
      }
      .desc {
        margin: 0 10px 10px;
        height: 18px;
        font-size: 12px;
        span-align: center;
        span-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #b0b0b0;
      }
      .price {
        span-align: center;
        color: $price;
      }
    }
  }
}
//产品收藏添加购物车
.pro-handle-icon {
  display: none;
  position: absolute;
  height: 24px;
  top: 14px;
  cursor: pointer;
  padding: 3px 4px;
  span {
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.2s linear;
    color: $theme-color;
  }
  &:hover {
    span {
      opacity: 1;
      font-weight: 550;
    }
    // .icon {
    //   color: $theme-color;
    // }
  }
  .icon {
    font-size: 18px;
    vertical-align: -1px;
    margin-right: 3px;
    color: $theme-color;
    // color:#FFF;
  }
  &.pro-collet-icon {
    left: 10px;
  }
  &.pro-addcart-icon {
    right: 10px;
  }
}
.el-tag {
  margin-top: 6px;
  margin-left: 10px;
  border: none;
}
.el-tag--mini {
  line-height: 20px;
}
</style>